/**
 * GET /auth/me - Get current user info
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'

export const meAction: ActionDefinition = {
  key: 'me',
  label: { en: 'Get Current User', es: 'Obtener usuario actual' },
  icon: 'mdi:account',
  scope: 'module',
  hidden: true,
  method: 'GET',
  middleware: (ctx) => ctx.core.middleware['auth'] as MiddlewareHandler,
  handler: async (ctx, input, c) => {
    const { _authUserId } = input as { _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const authService = ctx.services.get<AuthService>('auth')
    const result = await authService.me(_authUserId)

    const impersonation = c?.get('impersonation')
    if (impersonation?.isImpersonating) {
      return { ...result, impersonation }
    }
    return result
  }
}
